import React from "react";

// Small, subtle "Sample photo" tag shown in a corner of fallback (stock)
// cover images. Real photos never render this tag — callers gate on
// `isFallbackImage(location)` from lib/stockImages.
export default function SamplePhotoTag({ className = "", testId = "sample-photo-tag" }) {
  return (
    <span
      data-testid={testId}
      className={
        "pointer-events-none absolute bottom-2 left-2 inline-flex items-center " +
        "px-1.5 py-0.5 rounded text-[10px] font-medium tracking-wide " +
        "bg-black/45 text-white/90 backdrop-blur-sm " +
        className
      }
    >
      Sample photo
    </span>
  );
}
